export default {
      id: "trapezoid-usage",
      viewBox: "0 0 21 30",
      url: __webpack_public_path__ + "icons.svg#trapezoid",
      toString: function () {
        return this.url;
      }
    }